import PublicTeacherDevelopmentTable from "./PublicTeacherDevelopmentTable";

export default PublicTeacherDevelopmentTable